import React from 'react';
import { DonorMatchBtn, UnmatchButtonItem } from '../../style';

interface AutoIntegrationUnmatchDonorRowButtonProps {
    donorId: number;
    pageNumber: number;
    openUnMatchModal: (donorId: number, pageNumber: number) => void;
    isReadOnly: boolean;
}

const AutoIntegrationUnmatchDonorRowButton: React.FCC<
    AutoIntegrationUnmatchDonorRowButtonProps
> = ({ donorId, pageNumber, openUnMatchModal, isReadOnly }) => {
    const openModal = () => {
        openUnMatchModal(donorId, pageNumber);
    };
    return (
        <UnmatchButtonItem>
            <DonorMatchBtn
                disabled={isReadOnly}
                loadingIndicator="ring"
                name="match"
                onClick={openModal}
                size="small"
                style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}
                text="Match"
                variant="secondary"
            />
        </UnmatchButtonItem>
    );
};

export default AutoIntegrationUnmatchDonorRowButton;
